(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !Shopify.designMode) return;
  try {
    
  class CollectionDescription extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        textContainers: this.querySelectorAll('.collection-description--truncatable'),
      };

      this.initTruncation();
    }

    initTruncation() {
      this.elements.textContainers.forEach((container) => {
        const showMoreButton = container.nextElementSibling;

        if (!showMoreButton) return;

        if (container.scrollHeight > container.offsetHeight) {
          container.classList.add('is-truncated');
          showMoreButton.classList.add('is-visible');
        }

        container.classList.remove('initial');

        showMoreButton.addEventListener('click', () => {
          container.classList.toggle('is-truncated');
          if (container.classList.contains('is-truncated')) {
            showMoreButton.textContent = 'Read More';
          } else {
            showMoreButton.textContent = 'Read Less';
          }
        });
      });
    }
  }

  customElements.define('collection-description', CollectionDescription);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features-columns"] && !Shopify.designMode) return;
  try {
    

function setHeight(el, val) {
  if (typeof val === "function") val = val();
  if (typeof val === "string") el.style.height = val;
  else el.style.height = val + "px";
}

var equalheight = function(elements){
  var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;

  Array.from(elements).forEach((el,i) => {
    el.style.height = "auto";
    topPostion = el.offsetTop;
    if(currentRowStart != topPostion){
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest)
      }
      rowDivs.length = 0;
      currentRowStart = topPostion;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace("px", ""))
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest = (currentTallest < parseFloat(getComputedStyle(el, null).height.replace("px", ""))) ? (parseFloat(getComputedStyle(el, null).height.replace("px", ""))) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest)
    }
  })
}

class ProductFeatures extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      featureColumnsElement: this.querySelector('.product-features__columns'),
      productFeatureTitleElements: this.querySelectorAll('.product-feature__title'),
    };

    window.addEventListener("load", () => {
      equalheight(this.elements.productFeatureTitleElements);
    });
    window.addEventListener("resize", () => {
      setTimeout(() => {
        equalheight(this.elements.productFeatureTitleElements);
      })
    });
  }
}

customElements.define('product-features', ProductFeatures);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
        theme.initAnimateOnScroll();
        theme.loadCarousels(productRecommendationsSection);

        function handleRecommendationsWidthChange(entries) {
          entries.forEach((entry) => {
            const element = entry.target;
            const isWide = element.offsetWidth > 280;
            element.classList.toggle('is-wide', isWide);
          });
        }

        const resizeRecommendationsObserver = new ResizeObserver(handleRecommendationsWidthChange);
        const productBlocks = productRecommendationsSection.querySelectorAll('.product-block');
        productBlocks.forEach((element) => {
          resizeRecommendationsObserver.observe(element);
        });
      }
    };
    request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
